import { create } from 'zustand';
import type { GrowthPathStep } from '../apis/growthPath';

interface GrowthPathStepSheetStore {
  step: GrowthPathStep | null;
  setStep: (step: GrowthPathStep | null) => void;
}

export const useGrowthPathStepSheetStore = create<GrowthPathStepSheetStore>(set => ({
  step: null,
  setStep: step => set({ step }),
}));
